import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { routerShape, withRouter, Link } from 'react-router';
import { FormattedMessage } from 'react-intl';

import { Shelves, ExternalArrow } from '@bibliocommons/base-icons';
import { childrenShape, shelfShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';

import HelpLinkContainer from '../../../containers/HelpLinkContainer';
import ShelfAddTitleButton from '../ShelfAddTitleButton';

import './EmptyShelf.scss';

function renderEmptyPublicShelf(shelf) {
  const shelfName = shelf.get('name');
  return (
    <div className="empty-public-shelf">
      <h2><FormattedMessage id="users_empty_shelf_heading" /></h2>
      <p>
        <FormattedMessage
          id="users_empty_shelf_description"
          values={{ shelf: <FormattedMessage id={`label_${shelfName}_shelf`} /> }} />
      </p>
    </div>
  );
}

function renderEmptyOwnerShelf(shelf, owner, currentUserShelves, shelfActions) {
  return (
    <div className="empty-owner-shelf">
      <h2><FormattedMessage id="empty_shelf_heading" /></h2>
      <p><FormattedMessage id="empty_shelf_description" /></p>
      <p>
        <HelpLinkContainer page="020shelves/000my_shelves" showIcon={false}>
          <ScreenReaderMessage>
            <FormattedMessage id="ada_shelves_learn_more" />
          </ScreenReaderMessage>
          <span aria-hidden>
            <FormattedMessage id="label_about_my_shelves" />
          </span>
          <ExternalArrow className="help-link-icon" />
        </HelpLinkContainer>
      </p>

      <div className="add-title-button-wrapper">
        <ShelfAddTitleButton
          shelfActions={shelfActions}
          currentShelfName={shelf.get('name')}
          currentUserShelves={currentUserShelves}
          ownerId={owner.get('id')} />
      </div>
    </div>
  );
}

function renderEmptySearchResults(router) {
  return (
    <div className="empty-search-results">
      <h2><FormattedMessage id="empty_shelf_no_titles" /></h2>
      <p><FormattedMessage id="empty_shelf_no_titles_description" /></p>
      <p>
        <Link to={router.location.pathname}>
          <FormattedMessage id="clear_filters" />
        </Link>
      </p>
    </div>
  );
}

function renderContent(shelf, owner, currentUserShelves, shelfActions, router) {
  const searchFilters = shelf.getIn(['query', 'filters']);

  if (searchFilters && !searchFilters.isEmpty()) {
    return renderEmptySearchResults(router);
  }

  return owner.get('loggedIn') ? renderEmptyOwnerShelf(shelf, owner, currentUserShelves, shelfActions) : renderEmptyPublicShelf(shelf);
}

export function EmptyShelf({ shelf, owner, currentUserShelves, shelfActions, router, children }) {
  return (
    <div className="cp-empty-shelf">
      <div className="empty-shelf-content">
        <Shelves color="currentColor" className="empty-shelf-icon" />
        {renderContent(shelf, owner, currentUserShelves, shelfActions, router)}
      </div>
      {children}
    </div>
  );
}

EmptyShelf.propTypes = {
  shelf: shelfShape.isRequired,
  owner: userIdentityShape.isRequired,
  currentUserShelves: ImmutablePropTypes.map.isRequired,
  shelfActions: PropTypes.objectOf(PropTypes.func).isRequired,
  router: routerShape.isRequired,
  children: childrenShape
};

export default withRouter(EmptyShelf);



// WEBPACK FOOTER //
// ./app/components/shelves/EmptyShelf/EmptyShelf.jsx